(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Sol sabit bar + teklif formu — yalnızca anasayfada init edilir (index bundle).
  DNB.LeftBar = {
    init: function () {
      var bar = document.querySelector("[data-left-bar]");
      if (!bar || bar.getAttribute("data-left-bar-init") === "1") return;
      bar.setAttribute("data-left-bar-init", "1");

      var hero = document.querySelector(".home-hero");
      var openBtn = bar.querySelector("[data-left-bar-open]");
      var closeBtn = bar.querySelector("[data-left-bar-close]");
      var form = bar.querySelector("[data-left-bar-form]");

      function updateTheme() {
        if (!hero) return;
        var heroBottom = hero.getBoundingClientRect().bottom;
        // dark text once the bar sits below the hero area
        bar.classList.toggle("is-dark", heroBottom <= bar.getBoundingClientRect().top + 40);
      }
      updateTheme();
      window.addEventListener("scroll", updateTheme, { passive: true });

      if (openBtn && form) {
        openBtn.addEventListener("click", function () {
          form.classList.add("is-open");
          bar.classList.add("has-form");
        });
      }
      if (closeBtn && form) {
        closeBtn.addEventListener("click", function () {
          form.classList.remove("is-open");
          bar.classList.remove("has-form");
        });
      }
    }
  };
})(window, document);
